import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSort, Sort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Option } from '../../engine/models/models';
import { AreaType } from '../../enum';
import { Utilities } from '../../helpers/utilities';
import { AreasService } from '../../services/areas.service';
import { ExportPicturesService } from '../../services/export-pictures.service';
import { Globals } from '../../services/globals';
import { CustomFeaturesAddendumComponent } from '../custom-features-addendum/custom-features-addendum.component';

@Component({
  selector: 'cart-details',
  templateUrl: './cart-details.component.html',
  styleUrls: ['./cart-details.component.css']
})

export class CartDetailsComponent implements OnInit, AfterViewInit {
  utilities: Utilities = new Utilities();
  subTotal: number;
  //total: number;
  isShowIncluded: boolean;
  @Input() checked: boolean;
  @Output() onOptionSelected = new EventEmitter<Option>();
  @ViewChild(MatSort) sorting: MatSort;

  constructor(public globals: Globals,
    public dialog: MatDialog,
    private areasService: AreasService,
    private toastr: ToastrService,
    public exportPicturesService: ExportPicturesService,
    public ngxUiLoaderService: NgxUiLoaderService) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.selectedOptions(false);
    this.initalizeAreas();
  }

  exportPictures() {
    //this.ngxUiLoaderService.start();
    this.exportPicturesService.exportPictures(this.globals.appointment.contractId).subscribe(record => {
      const detailedReport = record.responseContent;
      const linkSource = 'data:application/pdf;base64,' + detailedReport;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = record.fileName;
      downloadLink.click();
      //this.ngxUiLoaderService.stop();
    }, error => {
      this.toastr.error("An unknown error occurred.", "Error")
      //this.ngxUiLoaderService.stop();
    });
  }

  initalizeAreas() {
    if (!this.globals.areas) {
      this.areasService.getAreas().subscribe(areas => {
        this.globals.areas = areas.filter(x => x.areaType == AreaType.Area);
        this.getParentArea();
      });
    }
    else {
      this.getParentArea();
    }
  }
  getDescriptionWithStyle(option: Option) {
    let descriptionWithStyle: string;
    if (option.styleSelections && option.styleSelections.length) {
      for (const style of option.styleSelections) {
        for (const choice of style.styleChoices) {
          if (choice.isSelected) {
            if (!descriptionWithStyle) {
              descriptionWithStyle = option.description + " : " + choice.description;
            }
            else {
              descriptionWithStyle += ", " + choice.description;
            }
          }
        }
      }
      if (!descriptionWithStyle) {
        descriptionWithStyle = option.description;
      }
      return descriptionWithStyle;
    }

    else {
      descriptionWithStyle = option.description;
      return descriptionWithStyle;
    }

  }

  selectedOptions(showAll: boolean) {
    this.globals.engine.selectedOptions = [];
    for (const option of this.globals.engine.optionDefinitions) {

      if (option.areaId > 1 && option.isVisible) {
        if (option.childOptions) {
          let childOption: Option;
          if (showAll) {
            childOption = option.childOptions.find(x => x.isSelected || x.isAdded);
          }
          else {
            childOption = option.childOptions.find(x => (x.isSelected || x.isAdded) && option.selectedOption && option.selectedOption.price > 0);

          }
          if (childOption) {
            this.globals.engine.selectedOptions.push(childOption);
          }
        }
        else {
          if (showAll) {
            if (option.isSelected || option.isAdded)
              this.globals.engine.selectedOptions.push(option);
          }
          else {
            if ((option.isSelected || option.isAdded) && option.price > 0 && !option.isRequired) {
              this.globals.engine.selectedOptions.push(option);
            }
          }
        }
      }
    }
    this.globals.engine.selectedOptions = this.globals.engine.selectedOptions.sort((a, b) => (+a.price * a.quantity) - (+b.price * b.quantity)).sort((c, d) => +c.isClientSelected - +d.isClientSelected);
    this.getParentArea();
  }

  viewAndDownload() {
    const dialogRef = this.dialog.open(CustomFeaturesAddendumComponent, {
      disableClose: true,
      minWidth: '80%',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onChange() {
    this.isShowIncluded = !this.isShowIncluded;
    this.selectedOptions(this.isShowIncluded);
  }

  viewOption(option: Option) {
    let parentOption: Option;
    this.globals.viewOptionFromCart = true;
    this.globals.displayRooms = false;
    if (option.parentOptionId) {
      parentOption = this.globals.engine.optionDefinitions.filter(q => q.optionId === option.parentOptionId)[0];
      this.globals.previousSelectedOption = parentOption;
      this.onOptionSelected.emit(parentOption);
    }
    else {
      this.globals.previousSelectedOption = option;
      this.onOptionSelected.emit(option);
    }


  }
  getParentArea() {
    if (this.globals.engine.selectedOptions) {
      for (const option of this.globals.engine.selectedOptions) {
        if (option.areaId > 0) {
          this.globals.areas.forEach(area => {
            const subArea = area.subAreas.find(x => x.id === option.areaId);
            if (subArea) {
              subArea.parentDisplayOrder = area.displayOrder;
              subArea.parentName = area.name;
              option.area = subArea;

              option.areaName = area.name;
            }
          });
        }
        if (!option.areaName) {
          option.areaName = "N/A";
        }
      }

      this.globals.engine.selectedOptions = this.globals.engine.selectedOptions.sort((a, b) => (a.area.parentDisplayOrder - b.area.parentDisplayOrder) || (a.area.displayOrder - b.area.displayOrder) || a.areaName.localeCompare(b.areaName));
      //this.globals.engine.selectedOptions = this.globals.engine.selectedOptions.sort((a, b) => b.parentAreaId - a.parentAreaId);
      this.calculateSubTotal();
      this.sorting.sort({ id: null, start: 'asc', disableClear: true });
    }
  }

  calculateSubTotal() {
    this.subTotal = this.globals.engine.selectedOptions.reduce((acc, obj) => acc + (obj.price * obj.quantity), 0);
    //this.total = this.subTotal + this.globals.engine.appointmentDetails.pricing.floorplanBasePrice;
  }

  getOptionPrice(option: Option) {
    if (option.isRFP) {
      return "RFP";
    }
    if (option.quantity && option.quantity > 1) {
      const price = option.price * option.quantity;
      return this.utilities.formatAsMoney(price);
    }
    else {
      if (option.quantity < 1) {
        option.quantity = 1;
      }
      return this.utilities.formatAsMoney(option.price);
    }
  }

  sort(sort: Sort) {
    if (sort.direction === 'asc') {
      this.globals.engine.selectedOptions.sort((a, b) => a[sort.active] > b[sort.active] ? 1 : a[sort.active] < b[sort.active] ? -1 : 0);
    }
    else {
      this.globals.engine.selectedOptions.sort((a, b) => a[sort.active] < b[sort.active] ? 1 : a[sort.active] > b[sort.active] ? -1 : 0);
    }
  }

  removeSelectedOptions(option: Option) {
    this.globals.engine.setDirty();
    if (option.isAdded || option.isSelected) {
      option.isAdded = false;
      option.isSelected = false;
      option.isClientSelected = false;
      option.selectedOption = null;
      option.quantity = 1;
    }
    const parentOption = this.globals.engine.optionDefinitions.filter(q => q.optionId === option.parentOptionId)[0];
    if (parentOption) {
      parentOption.selectedOption = null;
      parentOption.quantity = 1;
      parentOption.selectedOption = this.setIncludedAsSelectedOption(parentOption);
      parentOption.selectedPictureGallery = [];
      parentOption.selectedPictureGallery = this.globals.engine.getSelectedOptionPictures(parentOption);
      this.globals.engine.updateGalleryPicture(parentOption);


    }
    const index: number = this.globals.engine.selectedOptions.indexOf(option);
    if (index !== -1) {
      this.globals.engine.selectedOptions.splice(index, 1);
      if (option.price) {
        option.isAdded = false;
        //this.globals.engine.calculateOptionalPrice(option);
        this.globals.engine.updateCalculations();
      }
      this.calculateSubTotal();
    }
    this.globals.engine.selectedOptionChanged.emit(parentOption);
    this.globals.engine.optionRemoved.emit(parentOption);
    this.globals.engine.selectionUpdated.emit(parentOption);

  }
  setIncludedAsSelectedOption(parentOption: Option) {
    if (parentOption.childOptions) {
      const childOption = parentOption.childOptions.find(x => x.price === 0);
      if (childOption) {
        childOption.isSelected = true;
        return childOption;
      }
    }
    return null;
  }
  getToolTip(option: Option) {
    if (!option.isClientSelected) {
      return "This is an included feature and cannot be removed.";
    }
    return null;
  }
  closeDialog() {
    this.dialog.closeAll();
  }
}
